// *消息内容类型
export enum EMessageContentType {
    /// <summary>
    /// 文本
    /// </summary>
    Text = 0,
    /// <summary>
    /// Markdown 文本
    /// </summary>
    Markdown = 10,
    /// <summary>
    /// HTML 文本
    /// </summary>
    HTML = 20,
}